import { InterventionExternalCode } from 'ts-types/api.enums';

const firstDoseValues = [
  InterventionExternalCode.VACCINATION_DOSE_1,
  InterventionExternalCode.VACCINATION_CHILD_DOSE_1
];

export const isVaccination = (externalCode: InterventionExternalCode | undefined): boolean => {
  if (!externalCode) {
    return false;
  }
  return externalCode.startsWith("VACCINATION_");
};

export const isFirstDoseVaccination = (externalCode: InterventionExternalCode | undefined): boolean => {
  return externalCode !== undefined && firstDoseValues.includes(externalCode);
};

export const getSecondDoseVaccinationExternalCode = (
    externalCodeFirstDose: InterventionExternalCode): InterventionExternalCode => {

  if (InterventionExternalCode.VACCINATION_DOSE_1 === externalCodeFirstDose) {
    return InterventionExternalCode.VACCINATION_DOSE_2;
  } else if (InterventionExternalCode.VACCINATION_CHILD_DOSE_1 === externalCodeFirstDose) {
    return InterventionExternalCode.VACCINATION_CHILD_DOSE_2;
  }

  // fallback
  return InterventionExternalCode.VACCINATION_DOSE_2;
};

export const isTestIntervention = (externalCode: InterventionExternalCode | undefined): boolean => {
  if (!externalCode) {
    return false;
  }
  return externalCode.endsWith("_TEST");
};
